import http from '../http.service'

export class BaseDataService {
  constructor (baseEntityUrl) {
    this.baseEntityUrl = baseEntityUrl
    this.http = http
  }

  getCustomItems (relativeUrl) {
    return this.http.get(`${this.baseEntityUrl}/${relativeUrl}`)
      .then((res) => res.data.items)
  }
}
